// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SavedViewsDropdown_dropdownMenu__T8tvr {
  min-width: 300px;
  max-width: 400px;
  max-height: 400px;
  overflow-y: auto;
  padding: 8px 0;
}
.SavedViewsDropdown_dropdownMenu__T8tvr .ant-dropdown-menu-item {
  padding: 8px 16px;
  border-bottom: 1px solid var(--border-color-1, #f0f0f0);
}
.SavedViewsDropdown_dropdownMenu__T8tvr .ant-dropdown-menu-item:last-child {
  border-bottom: none;
}

.SavedViewsDropdown_menuItem__s3YQK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.SavedViewsDropdown_avatar__Pkl7O {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  margin-right: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-color-2, #fff);
  border: 1px solid var(--border-color-1, #f0f0f0);
  overflow: hidden;
}
.SavedViewsDropdown_avatar__Pkl7O img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.SavedViewsDropdown_viewInfo__M0Is1 {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
  padding-right: 12px;
}

.SavedViewsDropdown_viewName__pn8If {
  font-weight: 500;
  color: var(--text-color-1, #1f2937);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SavedViewsDropdown_viewDate__5eOXg {
  font-size: 12px;
  color: var(--text-color-3, #9ca3af);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SavedViewsDropdown_deleteBtn__WoY9K {
  color: var(--text-color-3, #9ca3af);
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.SavedViewsDropdown_deleteBtn__WoY9K:hover {
  color: var(--danger-color, #ff4d4f);
  background: rgba(255, 77, 79, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/SavedViewsDropdown/SavedViewsDropdown.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACF;AACE;EACE,iBAAA;EACA,uDAAA;AACJ;AACI;EACE,mBAAA;AACN;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,gDAAA;EACA,gBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,eAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,mCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIE;EACE,mCAAA;EACA,kCAAA;AAFJ","sourcesContent":[".dropdownMenu {\n  min-width: 300px;\n  max-width: 400px;\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 8px 0;\n\n  :global(.ant-dropdown-menu-item) {\n    padding: 8px 16px;\n    border-bottom: 1px solid var(--border-color-1, #f0f0f0);\n    \n    &:last-child {\n      border-bottom: none;\n    }\n  }\n}\n\n.menuItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  margin-right: 12px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--background-color-2, #fff);\n  border: 1px solid var(--border-color-1, #f0f0f0);\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n}\n\n.viewInfo {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  padding-right: 12px;\n}\n\n.viewName {\n  font-weight: 500;\n  color: var(--text-color-1, #1f2937);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.viewDate {\n  font-size: 12px;\n  color: var(--text-color-3, #9ca3af);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.deleteBtn {\n  color: var(--text-color-3, #9ca3af);\n  padding: 4px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    color: var(--danger-color, #ff4d4f);\n    background: rgba(255, 77, 79, 0.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownMenu": `SavedViewsDropdown_dropdownMenu__T8tvr`,
	"menuItem": `SavedViewsDropdown_menuItem__s3YQK`,
	"avatar": `SavedViewsDropdown_avatar__Pkl7O`,
	"viewInfo": `SavedViewsDropdown_viewInfo__M0Is1`,
	"viewName": `SavedViewsDropdown_viewName__pn8If`,
	"viewDate": `SavedViewsDropdown_viewDate__5eOXg`,
	"deleteBtn": `SavedViewsDropdown_deleteBtn__WoY9K`
};
export default ___CSS_LOADER_EXPORT___;
